export default function getOffsetModifier(offset) {
  return {
    name: 'offset',
    options: {
      offset
    }
  };
}
